module.exports = __webpack_public_path__ + "03_very_short_grey.8f1f9584.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_very_short_grey.png
// module id = DGMd
// module chunks = 0